import React, { useEffect, useRef } from "react";
import type { IProductVideo } from "@src/types/AppTypes";

const ProductVideo: React.FC<IProductVideo> = React.memo(
  ({ vidUrl, isFromNewsPage }) => {
    const ref = useRef<HTMLVideoElement>(null);

    useEffect(() => {
      const observer = new IntersectionObserver(
        (e) => {
          e.forEach((ee) => {
            if (ee.isIntersecting) {
              ref.current?.play();
            } else {
              ref.current?.pause();
            }
          });
        },
        { threshold: 1 }
      );

      if (ref.current) {
        observer.observe(ref.current);
      }
    }, []);

    return (
      <div
        className={`h-full relative ${
          isFromNewsPage ? "news-carousel-video" : ""
        }`}
      >
        <video
          ref={ref}
          className="h-[550px] max-sm:h-[400px] max-h-[inherit] object-contain relative z-10 w-full slider-video"
          controls
          disablePictureInPicture
          playsInline
        >
          <source src={vidUrl} type="video/mp4" />
        </video>
        <video
          className="h-[550px] max-sm:h-[400px] max-h-[inherit] object-cover blur-sm absolute top-0 w-full"
          playsInline
          disablePictureInPicture
          autoPlay={false}
        >
          <source src={vidUrl} type="video/mp4" />
        </video>
      </div>
    );
  }
);

export default ProductVideo;
